/**
 * Normalize calendar Lambda / Google API errors for dashboard UI.
 */
export function parseCalendarListError(raw) {
  const text = String(raw || '').trim();
  const lower = text.toLowerCase();

  if (
    lower.includes('insufficientauthentication scopes') ||
    lower.includes('insufficient permission') ||
    lower.includes('insufficientpermissions') ||
    lower.includes('insufficient authentication scopes')
  ) {
    return {
      code: 'INSUFFICIENT_SCOPES',
      title: 'Need calendar list permission',
      message:
        'Google is connected for busy-time sync only, not for listing calendars. ' +
        'Use **Connect Google** again after your team enables full calendar read scope on the calendar API ' +
        '(USE_FULL_CALENDAR_SCOPE), or enter a calendar ID manually below.',
      detail: text
    };
  }

  if (lower.includes('not connected')) {
    return {
      code: 'NOT_CONNECTED',
      title: 'Not connected yet',
      message: 'Click Connect Google and finish consent in the popup, then Refresh list.',
      detail: text
    };
  }

  return {
    code: 'UNKNOWN',
    title: 'Could not load calendars',
    message: text.length > 280 ? `${text.slice(0, 280)}…` : text || 'Unknown error',
    detail: text
  };
}
